import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './IconLogout.module.css';

const IconLogout = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.2909 8.50899V4.69081C14.2909 3.42558 13.2652 2.3999 12 2.3999L5.89089 2.3999C4.62565 2.3999 3.59998 3.42558 3.59998 4.69081L3.59998 18.4363C3.59998 19.7015 4.62565 20.7272 5.89088 20.7272H12C13.2652 20.7272 14.2909 19.7015 14.2909 18.4363V14.6181M17.3454 14.6181L20.4 11.5635M20.4 11.5635L17.3454 8.50899M20.4 11.5635L7.41816 11.5635"
        stroke="#535763"
        fill="none"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const { string } = PropTypes;

IconLogout.defaultProps = {
  className: null,
  rootClassName: null,
};

IconLogout.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconLogout;
